import script from "./Districts.vue?vue&type=script&setup=true&lang=js"
export * from "./Districts.vue?vue&type=script&setup=true&lang=js"

import "./Districts.vue?vue&type=style&index=0&id=730206ae&scoped=true&lang=scss"

import exportComponent from "/home/signal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-730206ae"]])

export default __exports__